export enum UserAccountStatus {
  ACTIVE = 'Active',
  ONBOARDING = 'Onboarding',
  SET_PASSWORD_TOKEN_EXPIRED = 'Set password token expired',
}
